module.exports = __webpack_public_path__ + "img/interaction-response-rate.a242e12e.png";